import React from "react";

const ErrorText = ({ children }) => {
  if (!children) return null;

  return <div className="text-red control-text mb-3">{children}</div>;
};

export default ErrorText;
